import { render, staticRenderFns } from "./FormInputErrorPlaceholder.vue?vue&type=template&id=8a485690&scoped=true&"
import script from "./FormInputErrorPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FormInputErrorPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a485690",
  null
  
)

export default component.exports